<template>
  <div class="ccckDetail">
    <div
        style="
            position: absolute;
             right: 50px;
             top: 110px;
           font-size: 40px;
          color: rgb(96, 98, 102);
          cursor: pointer;
          "
        @click="closePage"
    >
      <i class="el-icon-circle-close" />
    </div>
    <div v-loading="loading" class="mainContent">
      <div id="pdfMain" class="container">
        <div class="top_title">
          <span class="title_content">出口核查信息</span>
        </div>

        <div class="borderContainer">
          <div class="table_Container">
            <div class="section_one">
              <div
                  v-for="(item, index) in list_one"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired" class="requiredItem">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_two"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span
                        v-if="item.leftnameRequired"
                        class="requiredItem"
                    >*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span
                        v-if="item.rightNameRequired"
                        class="requiredItem"
                    >*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_three"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_four"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_five"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_six"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_seven"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_eight"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  class="listItem"
              >
                <div class="left_name">
                  <span>商品英文名</span>
                </div>
                <div class="right_detail">{{ formData['cdEnName'] }}</div>
              </div>
            </div>
            <div class="section_table">
              <div
                  v-for="(item, key) in table_list"
                  :key="key"
                  class="listItem"
              >
                <div v-for="(curItem, i) in item" :key="i" class="itemName">
                  <div v-if="curItem.isHead">
                    {{ curItem.name }}
                  </div>
                  <div v-if="curItem.isTd">
                    {{ formData[curItem.name] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_nine"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_ten"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_eleven"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_12"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_13"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_14"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_15"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_16"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_17"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_18"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_19"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 其他情况 -->
            <div class="section_other">
              <div class="leftTitle">{{ otherList.left_name }}</div>
              <div class="centerContent">
                <div
                    v-for="(item, index) in otherList.center"
                    :key="index"
                    class="top"
                >
                  {{ item.content }}
                </div>
              </div>
              <div class="rightChecked">
                <div
                    v-for="(item, index) in otherList.right"
                    :key="index"
                    class="top"
                >
                  <div style="display: inline-block">
                    <el-radio
                        v-model="formData[item.isActive]"
                        disabled
                        label="1"
                    >{{ item.contentY }}</el-radio>
                    <el-radio
                        v-model="formData[item.isActive]"
                        disabled
                        label="0"
                    >{{ item.contentN }}</el-radio>
                  </div>
                </div>
              </div>
            </div>
            <div
                class="instruction"
                style="background-color: rgb(234, 240, 247)"
            >
              <span>兹保证上述内容如实填写并将在出口活动中遵守国家有关法律法规规定。</span>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_20"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_21"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
            <div class="section_two">
              <div
                  v-for="(item, index) in list_22"
                  :key="index"
                  class="list_two_item"
              >
                <div class="left">
                  <div class="preTitle">
                    <span>{{ item.titleLeft }}</span>
                    <span v-if="item.leftnameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameLeft] }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="preTitle">
                    <span>{{ item.titleRight }}</span>
                    <span v-if="item.rightNameRequired">*</span>
                  </div>
                  <div class="preContent">
                    <span>{{ formData[item.nameRight] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section_one">
              <div
                  v-for="(item, index) in list_23"
                  :key="index"
                  class="listItem"
              >
                <div class="left_name">
                  <span>{{ item.title }}</span>
                  <span v-if="item.isRequired">*</span>
                </div>
                <div class="right_detail">{{ formData[item.name] }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="    margin-left: 10%;
    width: 80%;
    text-align: center;
    margin-bottom: 20px;">
      <p style="font-size: 25px;text-align: left">附件图片</p>
        <el-table
            :data="downloadFiles"
            border
            style="width: 100%"
        >
          <el-table-column fixed label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
              prop="fileName"
              label="文件名"
          />
          <el-table-column
              prop="expctrlName"
              label="描述"
          />
          <el-table-column
              label="图片/pdf文件"
          >
            <template slot-scope="scope">
              <el-button
                  type="primary"
                  size="mini"
                  round
                  @click="getPicUrl(scope.row.ftpUrl)"
              >查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import {kfckhcDetail} from "@/assets/js/system";
import {returnShowPic} from "@/assets/js/common";

export default {
  props: ['dataId'],
  components: {},
  data() {
    return {
      downloadFj: false,
      downloadFiles: [],
      loading: false,
      showBack: false,
      formData: {},
      submitForm: {},
      hcDialogVisible: false,
      radio: '1',
      list_23: [
      ],
      list_22: [
        {
          titleLeft: '回函意见',
          nameLeft: 'gjHhjgLabel',
          leftnameRequired: false,
          titleRight: '回函时间',
          nameRight: 'gjHhsj',
          rightNameRequired: false
        }
      ],
      list_21: [
        {
          title: '备注',
          name: 'spec',
          isRequired: false
        }
      ],
      list_20: [
        {
          titleLeft: '申请人',
          nameLeft: 'operator',
          leftnameRequired: false,
          titleRight: '申请日期',
          nameRight: 'appDte',
          rightNameRequired: false
        },
        {
          titleLeft: '联系人',
          nameLeft: 'tackMan',
          leftnameRequired: false,
          titleRight: '联系电话(手机)',
          nameRight: 'tackLink',
          rightNameRequired: false
        }
      ],
      otherList: {
        left_name: '其他情况',
        center: [
          {
            content: '是否了解国家相关易制毒化学品管理规定?'
          },
          {
            content: '是否了解进口商情况?'
          }
        ],
        right: [
          {
            contentY: '是',
            contentN: '否',
            isActive: 'otherNo1'
          },
          {
            contentY: '是',
            contentN: '否',
            isActive: 'otherNo2'
          }
        ]
      }, // 其他情况
      list_19: [
        {
          titleLeft: '生产商电话',
          nameLeft: 'produceTel',
          leftnameRequired: false,
          titleRight: '生产商传真',
          nameRight: 'produceFax',
          rightNameRequired: false
        }
      ],
      list_18: [
        {
          title: '最终用途',
          name: 'endcduse',
          isRequired: false
        },
        {
          title: '生产商名称',
          name: 'produceNa',
          isRequired: false
        },
        {
          title: '生产商中文住所',
          name: 'produceAdress',
          isRequired: false
        },
        {
          title: '生产商英文住所',
          name: 'produceAdressEn',
          isRequired: false
        }
      ],
      list_17: [
        {
          titleLeft: '最终用户电话',
          nameLeft: 'enduserTel',
          leftnameRequired: false,
          titleRight: '最终用户传真',
          nameRight: 'enduserFax',
          rightNameRequired: false
        }
      ],
      list_16: [
        {
          title: '最终用户中文',
          name: 'enduserCn',
          isRequired: false
        },
        {
          title: '最终用户英文',
          name: 'enduserEn',
          isRequired: false
        },
        {
          title: '最终用户住所中文',
          name: 'enduserAddress',
          isRequired: false
        },
        {
          title: '最终用户住所英文',
          name: 'enduserAddressEn',
          isRequired: false
        }
      ],
      list_15: [
        {
          titleLeft: '进口商电话',
          nameLeft: 'consigneeTel',
          leftnameRequired: false,
          titleRight: '进口商传真',
          nameRight: 'consigneeFax',
          rightNameRequired: false
        }
      ],
      list_14: [
        {
          title: '进口商(中间商)中文',
          name: 'consigneeCn',
          isRequired: false
        },
        {
          title: '进口商(中间商)英文',
          name: 'consigneeEn',
          isRequired: false
        },
        {
          title: '进口商住所中文',
          name: 'consigneeAddressCn',
          isRequired: false
        },
        {
          title: '进口商住所英文',
          name: 'consigneeAddress',
          isRequired: false
        }
      ],
      list_13: [
        {
          titleLeft: '营业执照注册号',
          nameLeft: 'carrIndNo',
          leftnameRequired: false,
          titleRight: '生产、经营、够用、许可（备案）号',
          nameRight: 'carrOrgCde；',
          rightNameRequired: false
        }
      ],
      list_12: [
        {
          title: '发货人中文住址',
          name: 'carrAddrCn',
          isRequired: false
        },
        {
          title: '发货人英文住址',
          name: 'carrAddrEn',
          isRequired: false
        }
      ],
      list_eleven: [
        {
          titleLeft: '发货人电话',
          nameLeft: 'carrTel',
          leftnameRequired: false,
          titleRight: '发货人传真',
          nameRight: 'carrFax',
          rightNameRequired: false
        }
      ],
      list_ten: [
        {
          title: '发货人英文名称',
          name: 'carrEn',
          isRequired: false
        }
      ],
      list_nine: [
        {
          titleLeft: '发货人代码',
          nameLeft: 'carrCde',
          leftnameRequired: false,
          titleRight: '发货人中文名称',
          nameRight: 'carrCn',
          rightNameRequired: false
        }
      ],
      table_list: [
        [
          {
            name: '规格、等级',
            isHead: true,
            isTd: false
          },
          {
            name: '数量 千克',
            isHead: true,
            isTd: false
          },
          {
            name: '单位(币别)美元',
            isHead: true,
            isTd: false
          },
          {
            name: '总值',
            isHead: true,
            isTd: false
          },
          {
            name: '总值折美元',
            isHead: true,
            isTd: false
          }
        ],
        [
          {
            name: 'spedes1',
            isHead: false,
            isTd: true
          },
          {
            name: 'quant1',
            isHead: false,
            isTd: true
          },
          {
            name: 'unitp1',
            isHead: false,
            isTd: true
          },
          {
            name: 'amont1',
            isHead: false,
            isTd: true
          },
          {
            name: 'amusd1',
            isHead: false,
            isTd: true
          }
        ],
        [
          {
            name: 'spedes2',
            isHead: false,
            isTd: true
          },
          {
            name: 'quant2',
            isHead: false,
            isTd: true
          },
          {
            name: 'unitp2',
            isHead: false,
            isTd: true
          },
          {
            name: 'amont2',
            isHead: false,
            isTd: true
          },
          {
            name: 'amusd2',
            isHead: false,
            isTd: true
          }
        ],
        [
          {
            name: '总计',
            isHead: true,
            isTd: false
          },
          {
            name: 'tQty',
            isHead: false,
            isTd: true
          },
          {
            name: '-----',
            isHead: true,
            isTd: false
          },
          {
            name: 'topOrAmt',
            isHead: false,
            isTd: true
          },
          {
            name: 'tUsAmt',
            isHead: false,
            isTd: true
          }
        ]
      ],
      list_eight: [
        {
          titleLeft: '商品代码（CAS号）',
          nameLeft: 'cdCde',
          leftnameRequired: false,
          titleRight: '商品名称',
          nameRight: 'cdCNa',
          rightNameRequired: false
        }
      ],
      list_seven: [
        {
          title: '代理人中文地址',
          name: 'brokerAddress',
          isRequired: false
        },
        {
          title: '代理人英文地址',
          name: 'brokerAddressEn',
          isRequired: false
        }
      ],
      list_six: [
        // {
        //   titleLeft: "代理人电话",
        //   nameLeft: "0312-456789",
        //   leftnameRequired: false,
        //   titleRight: "代理人传真",
        //   nameRight: "331082000006567",
        //   rightNameRequired: false,
        // },
      ],
      list_five: [
        // {
        //   title: "代理人英文",
        //   name: "ASDGFHFHFHF",
        //   isRequired: false,
        // },
      ],
      list_four: [
        {
          titleLeft: '收货人电话',
          nameLeft: 'conCarrTel',
          leftnameRequired: false,
          titleRight: '收货人传真',
          nameRight: 'conCarrFax',
          rightNameRequired: false
        }
      ],
      list_three: [
        {
          title: '空运/海运线路',
          name: 'saWays',
          isRequired: false
        },
        {
          title: '收货人英文',
          name: 'consignee',
          isRequired: false
        }
      ],
      list_two: [
        {
          titleLeft: '企业类型',
          nameLeft: 'corpTypeName',
          leftnameRequired: false,
          titleRight: '营业执照注册号',
          nameRight: 'exporterIndNo',
          rightNameRequired: false
        },
        {
          titleLeft: '成立日期',
          nameLeft: 'exporterIndDte',
          leftnameRequired: false,
          titleRight: '注册资本(万元)',
          nameRight: 'exporterRegMoney',
          rightNameRequired: false
        },
        {
          titleLeft: '出口商代码',
          nameLeft: 'ecorpCde',
          leftnameRequired: false,
          titleRight: '法定代表人',
          nameRight: 'exporterLegalName',
          rightNameRequired: false
        },
        {
          titleLeft: '电话',
          nameLeft: 'exporterTel',
          leftnameRequired: false,
          titleRight: '传真',
          nameRight: 'exporterFax',
          rightNameRequired: false
        },
        {
          titleLeft: '电子信箱',
          nameLeft: 'exporterEmail',
          leftnameRequired: false,
          titleRight: '联系人',
          nameRight: 'exporterLinkman',
          rightNameRequired: false
        },
        {
          titleLeft: '生产、经营、够用、许可（备案）号',
          nameLeft: 'exporterOrgCode',
          leftnameRequired: false,
          titleRight: '进口国/地区',
          nameRight: 'cnyCNa',
          rightNameRequired: false
        },
        {
          titleLeft: '贸易方式',
          nameLeft: 'trdCna',
          leftnameRequired: false,
          titleRight: '合同签订日期',
          nameRight: 'contrSigndate',
          rightNameRequired: false
        },
        {
          titleLeft: '出口合同(协议)号',
          nameLeft: 'contrNo',
          leftnameRequired: false,
          titleRight: '运输方式',
          nameRight: 'transCna',
          rightNameRequired: false
        },
        {
          titleLeft: '报关口岸',
          nameLeft: 'cusCna',
          leftnameRequired: false,
          titleRight: '付款方式',
          nameRight: 'payCna',
          rightNameRequired: false
        },
        {
          titleLeft: '中转国/地区',
          nameLeft: 'transName',
          leftnameRequired: false,
          titleRight: '最终目的国/地区',
          nameRight: 'endName',
          rightNameRequired: false
        },
        {
          titleLeft: '中转国/地区(英文)',
          nameLeft: 'transEna',
          leftnameRequired: false,
          titleRight: '最终目的国/地区(英文)',
          nameRight: 'endEna',
          rightNameRequired: false
        },
        {
          titleLeft: '运输许可证编号',
          nameLeft: 'transLicno',
          leftnameRequired: false,
          titleRight: '抵达日期',
          nameRight: 'arrDte',
          rightNameRequired: false
        },
        {
          titleLeft: '运输公司电话',
          nameLeft: 'transCompTel',
          leftnameRequired: false,
          titleRight: '运输日期',
          nameRight: 'transDte',
          rightNameRequired: false
        },
        {
          titleLeft: '运输公司传真',
          nameLeft: 'transCompFax',
          leftnameRequired: false,
          titleRight: '目的港(英文)',
          nameRight: 'purpPort',
          rightNameRequired: false
        },
        {
          titleLeft: '运输路线(英文)',
          nameLeft: 'transRout',
          leftnameRequired: false,
          titleRight: '运输公司(英文)',
          nameRight: 'transComp',
          rightNameRequired: false
        },
        {
          titleLeft: '商品用途',
          nameLeft: 'endcduse',
          leftnameRequired: false,
          titleRight: '预计出口日期',
          nameRight: 'estExpdate',
          rightNameRequired: false
        },
        {
          titleLeft: '出口许可证编号',
          nameLeft: 'expAuth',
          leftnameRequired: false,
          titleRight: '出口许可证日期',
          nameRight: 'expAuthDate',
          rightNameRequired: false
        },
        // {
        //   titleLeft: "出口许可证日期",
        //   nameLeft: "",
        //   leftnameRequired: false,
        //   titleRight: "预计进口日期",
        //   nameRight: "",
        //   rightNameRequired: false,
        // },
        {
          titleLeft: '出口许可证有效截止日期',
          nameLeft: 'expAuthValid',
          leftnameRequired: false,
          titleRight: '进口许可证日期',
          nameRight: 'impAuthDate',
          rightNameRequired: false
        },
        {
          titleLeft: '进口许可证有效截止日期',
          nameLeft: 'impAuthValid',
          leftnameRequired: false,
          titleRight: '进口核查编号',
          nameRight: 'impAuth',
          rightNameRequired: false
        }
      ],
      list_one: [
        {
          title: '商务部申请表号',
          name: 'appno',
          isRequired: false
        },
        {
          title: '出口核查函号',
          name: 'gjCkhh',
          isRequired: false
        },
        {
          title: '出口商中文',
          name: 'exporterNameCn',
          isRequired: false
        },
        {
          title: '出口商英文',
          name: 'exporterNameEn',
          isRequired: false
        },
        {
          title: '住所中文',
          name: 'exporterAddrCn',
          isRequired: false
        },
        {
          title: '住所英文',
          name: 'exporterAddrEn',
          isRequired: false
        }
      ]
    }
  },
  mounted() {
    if (this.dataId) {
      this.loadData()
    } else {
      this.closePage()
      this.$message({
        type: 'warning',
        message: '数据不存在!'
      })
    }
  },
  methods: {
    async getPicUrl(url) {

      const interfaceUrl  = returnShowPic()+url; // 你的图片接口

      // 2. 使用 window.open() 打开新窗口
      // 第一个参数是 URL，第二个参数是窗口名称（可自定义）
      // 第三个参数是新窗口的配置项（可选，如尺寸、位置等）
      const newWindow = window.open(interfaceUrl,'_blank'); //正式环境可以正常使用，测试环境若注释掉后端的"response.setHeader("Content-Type", "image/*");"也能正常显示

      // 3. 检查窗口是否成功打开（防止被浏览器弹窗拦截）
      if (!newWindow) {
        alert('无法打开新窗口，可能被浏览器的弹窗拦截器阻止了。请允许弹出窗口后重试。');
      }
    },
    loadData() {
      kfckhcDetail(this.dataId).then(res => {
        if (res.data.code === '000000') {
          this.formData = res.data.data
          this.downloadFiles =  res.data.data.fjxxs
        }
      })
    },
    closePage() {
      this.$parent.dataId = ''
      this.$parent.pupopShow = false
    }
  }
}
</script>
<style scoped lang="less">
.ccckDetail {
  //@y1213
  height: 100%;
  background-color: #eef1f9;
  padding-top: 15px;
  .title {
    background-color: white;
    //width: 98%;
    width: calc(100% - 40px);
    margin: 0px auto;
    height: 50px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title_left {
      padding-left: 5px;
      border-left: #2674e0 3px solid;
      color: #2674e0;
      font-weight: 700;
    }
  }
  .mainContent {
    background-color: #fff;
    width: calc(100% - 40px);
    margin: 0 auto;
    overflow-y: auto;
    height: calc(100% - 90px);
    .container {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      margin-bottom: 20px;
      .top_title {
        padding-top: 10px;
        display: flex;
        .title_content {
          width: 100%;
          font-weight: 700;
          text-align: center;
          font-size: 18px;
          display: inline-block;
          height: 50px;
          line-height: 50px;
          .bianhao {
            color: red;
            margin: 0 5px;
            display: inline-block;
            height: 50px;
            line-height: 50px;
          }
        }
      }
      .borderContainer {
        border: 1px solid #999999;
        background-color: #f7f7f7;
        .table_Container {
          height: calc(100% - 40px);
          //border: 1px solid #000;
          box-sizing: border-box;
          // 其他情况
          .section_other {
            border-bottom: 1px solid #999;
            display: flex;
            height: 60px;
            box-sizing: border-box;
            font-weight: 700;
            .leftTitle {
              background-color: rgb(234, 240, 247);
              border-bottom: 1px solid #999;
              height: 60px;
              padding-right: 10px;
              line-height: 60px;
              width: 300px;
              text-align: right;
              border-right: 1px solid #999;
              box-sizing: border-box;
            }
            .centerContent,
            .rightChecked {
              width: 50%;
              .top,
              .bottom {
                font-weight: normal;
                padding-left: 10px;
                text-align: left;
                line-height: 30px;
                height: 30px;
                border-bottom: 1px solid #999999;
              }
            }
            .centerContent {
              border-right: 1px solid #999;
            }
            .rightChecked {
              width: calc(50% - 300px);
              .top,
              .bottom {
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
          }
          .instruction,
          .submitToClose {
            padding-left: 10px;
            border-bottom: 1px solid #999;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            .fenzhengsm {
              color: red;
            }
          }
          .submitToClose {
            cursor: pointer;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            // button {
            //   cursor: pointer;
            //   background-color: red;
            //   height: 30px;
            //   width: 60px;
            //   line-height: 30px;
            //   border: 1px solid red;
            //   border-radius: 3px;
            //   color: #fff;
            // }
          }
          .section_one {
            width: 100%;
            .listItem {
              min-height: 30px;
              height: auto;
              border-bottom: 1px solid #999999;
              display: flex;
              line-height: 30px;
              text-align: right;
              .left_name {
                width: 300px;
                // height: 100%;
                font-weight: 700;
                border-right: 1px solid #999;
                padding-right: 10px;
                background-color: rgb(234, 240, 247);
              }
              .right_detail {
                width: calc(100% - 300px);
                padding-left: 10px;
                text-align: left;
              }
            }
          }
          .section_two {
            width: 100%;
            //border: 1px solid #999999;
            .list_two_item {
              width: 100%;
              min-height: 30px;
              height: auto;
              line-height: 30px;
              font-weight: bold;
              text-align: right;
              display: flex;
              border-bottom: 1px solid #999999;
              box-sizing: border-box;
              .left,
              .right {
                width: 50%;
                height: auto;
                border-right: 1px solid #999;
                display: flex;
                .preTitle {
                  padding-right: 10px;
                  width: 300px;
                  height: 100%;
                  border-right: 1px solid #999;
                  background-color: rgb(234, 240, 247);
                }
                .preContent {
                  width: calc(100% - 300px);
                  padding-left: 10px;
                  text-align: left;
                  font-weight: normal;
                }
              }
              .right {
                border-right: none;
              }
            }
          }
          .section_table {
            width: 100%;
            .listItem {
              height: 30px;
              display: flex;
              border-bottom: 1px solid #999999;
              .itemName {
                width: 20%;
                height: 100%;
                border-right: 1px solid #999;
                text-align: center;
                line-height: 30px;
                &:last-child {
                  border: none;
                }
              }
            }
            &:nth-of-type(2) {
              padding-right: 10px;
              text-align: right;
            }
          }
        }
      }
    }
  }
  .requiredItem {
    color: red;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    background-color: #aaa !important;
    &::after {
      background-color: #666;
      width: 5px;
      height: 5px;
    }
  }
  /deep/.el-radio__input.is-checked + .el-radio__label {
    color: #333;
  }
  /deep/.el-radio__inner {
    background-color: #eee;
    border: 1px solid #999;
  }
}
::-webkit-scrollbar-track {
  border-radius: 8px;
  -webkit-box-shodow: inset 0 0 6px rgba(200, 200, 200, 0.3);
  background-color: #f5f5f5;
}
::-webkit-scrollbar {
  width: 4px;
  border-radius: 8px;
  background-color: #f5f5f5;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
      linear,
      left bottom,
      left top,
      color-stop(1, rgb(100, 100, 100))
  );
}
/deep/.el-input.is-disabled .el-input__inner,
/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff !important;
}
/deep/.el-dialog__header {
  background-color: rgb(1, 0, 75);
  .header-title {
    color: #fff;
    text-align: left;
  }
}
</style>
